<template>
  <div>
    <div class="body">
      <div class="search">
        <div class="item">
          <el-button type="text" @click="$parent.$parent.type = 'chatSummary'">《《{{ $t('message.GoBack') }}</el-button>
        </div>
        <div class="item title">
          RAKUCHAT
        </div>
        <div class="item">
          <el-input v-model="datas.keyword" :placeholder="$t('message.FuzzySearchHistoricalRecords')"
            clearable></el-input>
        </div>
        <div class="item">
          <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!-- 发送对象 -->
          <el-table-column align="center" :label="$t('message.sendTo')" prop="send_realname" width="150">
          </el-table-column>
          <!-- 发送时间 -->
          <el-table-column align="center" :label="$t('message.sendingTime')" prop="MsgTime" width="150">
          </el-table-column>
          <!-- 聊天内容 -->
          <el-table-column align="center" :label="$t('message.chatContent')" prop="realname">
            <template slot-scope="scope">
              <div v-html="scope.row.Text" @dblclick="getRCComplainMessageContext(scope.row.id)" class="text-left">
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[100, 200, 500,]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <!-- 上下50条 -->
      <el-dialog :title="$t('message.upAndDown')" :close-on-click-modal="false" :visible.sync="dialogVisible"
        width="1200px" center>
        <div class="content">
          <div class="table">
            <el-table :data="upAndDownList" :default-sort="{ prop: 'date', order: 'descending' }"
              :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" max-height="600px">
              <!-- 发送对象 -->
              <el-table-column align="center" :label="$t('message.sendTo')" prop="send_realname" width="150">
              </el-table-column>
              <!-- 发送时间 -->
              <el-table-column align="center" :label="$t('message.sendingTime')" prop="MsgTime" width="150">
              </el-table-column>
              <!-- 聊天内容 -->
              <el-table-column align="center" :label="$t('message.chatContent')" prop="realname">
                <template slot-scope="scope">
                  <div v-html="scope.row.Text" class="text-left"></div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: { type: Number }
  },
  components: {

  },
  data() {
    return {
      datas: {
        user_id: '',
        keyword: '',
        page: 1,
        pageSize: 100,
      },
      total: 0,
      tableData: [],
      dialogVisible: false,
      upAndDownList: [],
    };
  },
  created() {
    this.datas.user_id = this.id
    this.$api.siteConfiguration.rakuchatMessageList(this.datas).then(res => {
      this.datas.page = res.data.lastPage - 0
      this.total = res.data.total
      this.$forceUpdate()
      this.$api.siteConfiguration.rakuchatMessageList(this.datas).then(result => {
        this.total = result.data.total
        this.tableData = result.data.data.reverse()
      })
    })
  },
  methods: {
    rakuchatMessageList() {
      this.datas.user_id = this.id
      this.$api.siteConfiguration.rakuchatMessageList(this.datas).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    search() {
      this.datas.page = 1
      this.rakuchatMessageList()
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.rakuchatMessageList()
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.rakuchatMessageList()
    },
    // RC聊天上下50条上下文
    getRCComplainMessageContext(id) {
      this.$api.siteConfiguration.getRCComplainMessageContext({ id }).then(res => {
        this.upAndDownList = res.data
        this.dialogVisible = true
      })
    },

  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;

  .item {
    margin-right: 24px;

  }

  .title {
    line-height: 40px;
    margin: 0 48px;
  }
}

.table {
  margin: 24px 0;


}

.text-left {
  text-align: left
}

.content {
  max-height: 650px;
  overflow-y: auto;
}
</style>